import { TAssistant } from '@answerr/types';
import { FC } from 'react';

const HomepagePlaceholder: FC<{ agentInfo: TAssistant; topics?: string[] }> = ({
  topics,
  agentInfo,
}) => {
  return (
    <div className="flex flex-col justify-center mb-6">
      <div className="text-center px-10 sm:px-0 flex flex-col justify-between">
        <div className="flex items-center justify-center">
          {agentInfo?.image ? (
            <img
              src={agentInfo?.image}
              alt="Organisation Logo"
              className="inline-block max-w-[200px] max-h-[100px]"
            />
          ) : (
            <span className="text-[40px] font-semibold ml-1 dark:text-white hidden sm:block">
              {agentInfo?.createdByOrg?.companyLogo ? (
                <img
                  src={agentInfo?.createdByOrg?.companyLogo}
                  alt="Company Logo"
                  className="inline-block max-w-[200px] max-h-[100px]"
                />
              ) : (
                agentInfo?.createdByOrg?.organisationName
              )}
            </span>
          )}
        </div>

        <h2 className="text-[20px] md:text-[30px] lg:text-[35px] 2xl:text-[40px] font-medium mt-4 dark:text-white">
          What do you want to know?
        </h2>
      </div>
    </div>
  );
};

export default HomepagePlaceholder;
